import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import romanCharactersAndNumbersOnly from '../../roman-characters-and-numbers-only';
import romanCharactersOnly from '../../roman-characters-only';
import {fiveDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const formatGRPostcode = (value) => {
  if (!value) return value;
  
  const trimmedValue = value.trim();
  const spacesRemoved = value.replace(/\s/g, '');
  return spacesRemoved.length === 5
    ? `${spacesRemoved.slice(0, 3)} ${spacesRemoved.slice(3)}`
    : trimmedValue;
};

const FieldDefinitionGR = [
  {
    ...addressee,
    validate: [required.fullName, max.lengthAddressee(35), romanCharactersOnly],
  },
  companyName,
  {
    ...streetName,
    validate: [required.address1, max.lengthAddress(35), romanCharactersAndNumbersOnly],
  },
  addressLine2,
  nameNumber,
  {
    ...townCity,
    validate: [required.townCity, max.lengthAddress(35), romanCharactersOnly],
  },
  county,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatGRPostcode,
    maxLength: 5,
    validate: [required.postCode, max.lengthPostCode(5), fiveDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
];

export default FieldDefinitionGR;
